import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { filter } from 'rxjs/operators';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { CreateNewItemComponent } from '../create-new-item/create-new-item.component';

import { QuestionSubTypeIdEnum, QuestionTypeIdEnum, ItemStatusEnum } from '@configs/questions.config';
import { ItemPreviewComponent } from '@items/item-preview/item-preview.component';
import { RoleManagementService } from '@services/role.management.service';
import { Subject, Subscription } from 'rxjs';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { videoAssetGroups } from '@configs/videoTitles';
export interface DialogData {
  name: any;
  id: number;
}
export interface PeriodicElement {
  itemBankName: any;
  itemDescription: any;
}

export interface getItemUuid {
  itemuuid: any;
  itemBasicDetails: any;
}

@Component({
  selector: 'app-question-list',
  templateUrl: './question-list.component.html',
  styleUrls: ['./question-list.component.scss']
})
export class QuestionListComponent implements OnDestroy {
  element1: void;
  flag: boolean = false;
  flag1: boolean = true;
  buttonWasClicked: boolean = false;
  backButtonFlag: boolean = true;
  displaydata: any;

  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;
  @ViewChild('itemPreview') itemPreview: ItemPreviewComponent;
  displayedColumns: string[] = ['itemBankName', 'itemDescription'];
  itemuuid: any;
  isEdit: boolean = false;
  getitemuuid: any;
  dataSource: any;
  itemId: any;
  questions: any;
  itemdetails: any;
  numberOfQuestions = 0;
  data: any;
  itemBasicData: any;
  isPublished = false;
  selectedTabIndex = 0;
  itemBasicDetails = {
    itemBankName: '',
    itemDescription: '',
    collectionId: '',
    itemBankId: '',
    isPublished: false,
  };
  setP: boolean;
  questionId: any;
  collectionId: any;
  testId: any;
  itemBankNameDisplay: any;
  itemBankNameDiscription: any;
  isNoQuestions = false;
  newItemname: any;
  ItemIdQue: any;
  dataAvailable: boolean = false;
  spinner: boolean = true;
  questionSubtypeId: any;
  questionTypeId: any;
  itemsDetailsSubscription: Subscription;
  updateItemSubscription: Subscription;
  editItemSubscription: Subscription;
  backButtonSubscription: Subscription;
  routeSubscription: Subscription;
  ItemStatusEnum = ItemStatusEnum;
  @ViewChild('table') table: MatTable<any>;
  itemStatusList: any = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(
    private itemservice: ItemService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private questionService: QuestionService,
    private dialog: MatDialog,
    public roleSer: RoleManagementService,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    public translate: TranslateService
  ) {

    this.translate.stream('items.statusArray').pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
      this.itemStatusList = translation;
    });
    if (!this.itemId) {
      this.LoadInitialData();
    }

    this.onTrainingIcon(videoAssetGroups.ItemManagementDetails);
  }

  LoadInitialData() {
    if (!this.routeSubscription) {
      this.routeSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(url => this.LoadInitialData());
    }
    this.backButtonSubscription = this.questionService.backButtonObs.subscribe(showBtnStatus => {
      if (showBtnStatus != '') {
        this.questions = '';
        console.log('backButtonObs question list')
        this.flag = !showBtnStatus;
        this.backButtonSubscription.unsubscribe();
        this.getItemDetails();
        this.dataAvailable = !showBtnStatus;
        this.isEdit = !showBtnStatus;
        this.buttonWasClicked = !showBtnStatus;
      }
    });
    this.spinner = false;
    this.itemId = sessionStorage.getItem('itemuuidId') //this.activatedRoute.snapshot.paramMap.get('id');
    this.itemservice.updateStatus.subscribe((isItemDisable) => {
      if (isItemDisable) {
        this.isPublished = isItemDisable;
      }
      this.displaydata = sessionStorage.backbtnflag;
    });
    this.collectionId = sessionStorage.defaultcollectionid;
    console.log('LoadInitialData question list')
    this.getItemDetails();
  }

  onTrainingIcon(groupName) {
    if (!this.hoverVideoApiCall) {
      this.itemservice.videoTutorial(groupName).subscribe(video => {
        this.itemservice.videoIcon.next(video.data);
        this.hoverVideoApiCall = true;
      });
    }
  }

  getItemDetails() {
    this.itemId = sessionStorage.getItem('itemuuidId') //this.activatedRoute.snapshot.paramMap.get('id');
    this.itemservice.getItemDetails(this.itemId).subscribe((resdata) => {
      console.log('getItemDetails question list')
      this.getitemuuid = resdata?.data?.itemuuId;
      this.itemservice.getItemuuid(this.getitemuuid);
      // this.itemservice.editedGetItem(resdata);
      this.itemBankNameDisplay = resdata?.data?.itemBankName;
      this.itemBankNameDiscription = resdata?.data?.itemDescription;
      this.prepareTableData(resdata);
      if (resdata?.data?.questions > 1) {
        this.isNoQuestions = true;
      } else {
        this.questions = new MatTableDataSource(resdata?.data?.questions.sort((a, b) => (a.questionOrder - b.questionOrder)));
      }
      this.itemservice.questionCountUpdate.next(resdata?.data?.questions.length);
      this.questionService.backButtonObs.next('')
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  prepareTableData(itemBasicData: any) {
    this.numberOfQuestions = itemBasicData?.data?.questions?.length;
    if (this.numberOfQuestions == 0) { this.dataAvailable = true; } else {
      this.dataAvailable = false; this.spinner = true;
    }
    this.questions = new MatTableDataSource(itemBasicData?.data?.questions.sort((a, b) => (a.questionOrder - b.questionOrder)));
    this.itemBasicDetails['itemBankName'] = itemBasicData?.data?.itemBankName;
    this.itemBasicDetails.itemDescription =
      itemBasicData?.data?.itemDescription;
    this.itemBasicDetails.collectionId = this.collectionId;
    this.itemBasicDetails.itemBankId = itemBasicData?.data?.itemBankId;
    this.ItemIdQue = this.itemBasicDetails.itemBankId;
    if (itemBasicData?.data?.statusName == ItemStatusEnum.Published) {
      this.isPublished = true;
      this.itemBasicDetails.isPublished = true;
    } else {
      this.isPublished = false;
      this.itemBasicDetails.isPublished = false;
    }
  }


  openNewItemDialog(): void {
    this.dialog.open(CreateNewItemComponent, { minWidth: '650px', data: { itemuuid: this.getitemuuid, itemBasicDetails: this.itemBasicDetails } });
  }

  toggle(clicked: boolean) {
    this.buttonWasClicked = clicked;
    this.dataAvailable = !clicked;
    this.flag = true;
    sessionStorage.removeItem('questionId');
    sessionStorage.removeItem('questionuuId');
    this.itemservice.selectedQuestionTab.next('tab1');
  }

  editQuestion(ele: any) {
    this.isEdit = true;
    this.element1 = ele;
    this.questionSubtypeId = ele.questionSubtypeId;
    this.questionTypeId = ele.questionTypeId;
    sessionStorage.setItem('questionId', ele.questionid);
    sessionStorage.setItem('questionuuId', ele.questionuuId);
  }

  deleteQuestion(questions: any) {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('itemDetails.TabQuestions.deletePopup.message'),
        buttonText: {
          ok: this.translate.instant('itemDetails.TabQuestions.deletePopup.btnYes'),
          cancel: this.translate.instant('itemDetails.TabQuestions.deletePopup.btnNo')
        } } });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.questionId = questions.questionuuId;
        this.questionService
          .deleteQuestion(this.questionId, this.itemId)
          .subscribe((quesData) => {
            // this.itemservice.questionCountUpdate.next(true);
            // this.questionService.reloadList.next(true);
            this.questions = new MatTableDataSource(this.questions?.data.filter(q => q.questionuuId != this.questionId));
            this.itemservice.questionCountUpdate.next(this.questions?.data?.length);
            this.numberOfQuestions = this.questions.data.length;
            this.notificationService.success(quesData.message); // This line used to display message
              // code commented because of multiple api calls
            // this.itemservice
            //   .getItemDetails(this.itemId)
            //   .subscribe((resData) => {
            //     if (resData?.data?.questions == 0) {
            //       this.isNoQuestions = true;
            //       this.dataAvailable = true;
            //     }
            //     this.numberOfQuestions = resData?.data?.questions?.length;
            //     resData?.data?.questions.sort((a, b) => (a.questionOrder - b.questionOrder));
            //     this.questions = new MatTableDataSource(
            //       resData?.data?.questions
            //     );

            //     this.itemBasicDetails['itemBankName'] =
            //       resData?.data?.itemBankName;
            //     this.itemBasicDetails.itemDescription =
            //       resData?.data?.itemDescription;
            //     this.itemBasicDetails.collectionId = this.collectionId;
            //     this.itemBasicDetails.itemBankId = resData?.data?.itemBankId;
            //   }, (error: any) => {
            //     this.webErrorService.handleAPIErrors(error);
            //   });
          }, (error: any) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });
      }
    });
  }

  navigateToSelectQuestionsType() {
    sessionStorage.setItem('ItemIdQue', this.ItemIdQue);
    this.router.navigate(['./selectquestiontype'], {
      relativeTo: this.activatedRoute,
      state: { itemId: this.itemId },
    });
  }
  navigateToItemLanding() {
    sessionStorage.removeItem('TestId');
    sessionStorage.removeItem('ItemIdQue');
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }

  openDialogPreview(): void {
    this.itemPreview.showPopup({ name: this.questions, id: this.itemId });
  }

  onPostAdded(event) {
    this.isEdit = event === 'false' ? false : true;
    this.questionService.backButtonObs.next(true);
  }

  dropTable(event: CdkDragDrop<any[]>) {
    if (!this.isPublished) {
      const prevIndex = this.questions.data.findIndex((d: any) => d === event.item.data);
      moveItemInArray(this.questions.data, prevIndex, event.currentIndex);
      // this.questions = new MatTableDataSource(this.dragdropdata);
      let payload = [];


      this.questions.data.forEach((a, index) => {
        let que = { questionid: a.questionid, questionorder: index + 1 };
        payload.push(que);
      });

      this.itemservice.arrangeOrder(this.getitemuuid, payload).subscribe((data) => {
        this.getItemDetails();
       });
    }
  }

  ngOnDestroy() {
    if (this.itemsDetailsSubscription) {
      this.itemsDetailsSubscription.unsubscribe();
    }
    if (this.updateItemSubscription) {
      this.updateItemSubscription.unsubscribe();
    }
    if (this.editItemSubscription) {
      this.editItemSubscription.unsubscribe();
    }
    if (this.backButtonSubscription) {
      this.backButtonSubscription.unsubscribe();
    }
  }
}
